/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Replacement status
 */
export type CardOverviewResponseCardsItemReplacementStatus = typeof CardOverviewResponseCardsItemReplacementStatus[keyof typeof CardOverviewResponseCardsItemReplacementStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardOverviewResponseCardsItemReplacementStatus = {
  REPLACEMENT_REQUESTED: 'REPLACEMENT_REQUESTED',
  REPLACEMENT_CARD_ISSUED: 'REPLACEMENT_CARD_ISSUED',
  REPLACEMENT_CANCELLED: 'REPLACEMENT_CANCELLED',
} as const;
